<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0"
  >
    <template #toggler>
      <stack-modal
                :show="show"
                title="Logout"
                @close="show=false"
                :hasBackdrop="false"
                :modal-class="{ [modalClass]: true }"
        >
            <p>Are You sure You want to logout</p>
            <slot name="modal-footer">
              <div class="modal-footer">
                  <button class="btn btn-primary" @click="ok">Ok</button>
                  <!-- <button @click="cancel">Cancel</button> -->
              </div>
          </slot>
          <div slot="modal-footer"></div>
        </stack-modal>
      <CHeaderNavLink>
        <div class="c-avatar">
          <!-- <img
            src="img/avatars/6.jpg"
            class="c-avatar-img "
          /> -->
          <CIcon name="cil-user"/>
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader tag="div" class="text-center" color="light">
      <strong>Account</strong>
    </CDropdownHeader>
    <CDropdownItem to="/profile">
      <!-- <CHeaderNavLink to="/profile"> -->
        <CIcon name="cil-user" /> Profile
      <!-- </CHeaderNavLink> -->
    </CDropdownItem>
    <CDropdownItem @click="show=true">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import StackModal from '@innologica/vue-stackable-modal'
export default {
  name: 'TheHeaderDropdownAccnt',
  components: {StackModal},
  data () {
    return { 
      show: false,
        modalClass: '',
      itemsCount: 42
    }
  },
  methods: {
    logOutFunction() {
      // if(confirm("Are You sure You want to logout"))
      // {
        localStorage.removeItem('token');
        localStorage.removeItem('userdata');
        localStorage.removeItem('advertfromdate');
        localStorage.removeItem('adverttodate');
        this.$router.push('/login');
      // }
    },
    cancel() {
      this.show = false
    },
    ok() {
      this.logOutFunction();
    }
  }
}
</script>

<style scoped>
  .c-icon {
    margin-right: 0.3rem;
  }
</style>